// eslint-disable-next-line no-unused-vars
import SubBubbleAgreementViewModel from '@/models/subBubbleAgreement/subBubbleAgreementViewModel'
// eslint-disable-next-line no-unused-vars
import SubBubbleAgreementDiscountViewModel from '@/models/subBubbleAgreement/subBubbleAgreementDiscountViewModel'
import SubBubbleAgreementDiscountDTO from '@/models/subBubbleAgreement/subBubbleAgreementDiscountDTO'
import CreateSubBubbleAgreementDTO from '@/models/subBubbleAgreement/createSubBubbleAgreementDTO'
import UpdateSubBubbleAgreementDTO from '@/models/subBubbleAgreement/updateSubBubbleAgreementDTO'

/**
 * Maps SubBubbleAgreementViewModel to CreateSubBubbleAgreementDTO
 * @param {SubBubbleAgreementViewModel} discount
 * @returns {CreateSubBubbleAgreementDTO}
 */
const createSubBubbleAgreementDTOMapper = (vm) => {
  return new CreateSubBubbleAgreementDTO({
    clientId: vm.clientId,
    clientGroupId: vm.clientGroupId,
    startDateLocal: vm.startDateLocal,
    endDateLocal: vm.endDateLocal,
    discounts: vm.discounts.map((d) => subBubbleAgreementDiscountDTOMapper(d)),
  })
}

/**
 * Maps SubBubbleAgreementViewModel to UpdateSubBubbleAgreementDTO
 * @param {SubBubbleAgreementViewModel} discount
 * @returns {UpdateSubBubbleAgreementDTO}
 */
const updateSubBubbleAgreementDTOMapper = (vm) => {
  return new UpdateSubBubbleAgreementDTO({
    id: vm.id,
    startDateLocal: vm.startDateLocal,
    endDateLocal: vm.endDateLocal,
    discounts: vm.discounts.map((d) => subBubbleAgreementDiscountDTOMapper(d)),
  })
}

/**
 * Maps SubBubbleAgreementDiscountViewModel to SubBubbleAgreementDiscountDTO
 * @param {SubBubbleAgreementDiscountViewModel} discount
 * @returns {SubBubbleAgreementDiscountDTO}
 */
const subBubbleAgreementDiscountDTOMapper = (discount) => {
  return new SubBubbleAgreementDiscountDTO({
    id: Number.isInteger(discount.id) ? discount.id : null,
    classificationId: discount.classificationId,
    discountType: discount.discountType,
    value: discount.value,
    candidateCount: discount.candidateCount,
  })
}

export { createSubBubbleAgreementDTOMapper, updateSubBubbleAgreementDTOMapper }
